export enum AddOnType {
  ExtendedWarranty = 1,
  Maintenance = 4,
  OptionToPurchase = 3,
}
export enum AddOnName {
  ExtendedWarranty = 'ExtendedWarranty',
  Maintenance = 'Maintenance',
  OptionToPurchase = 'OptionToPurchase',
}

export const AddOnTooltips: Record<string, string> = {
  'ExtendedWarranty': 'Prolonged warranty in addition to the standard warranty offered',
  'Maintenance': '<div>Maintenance that could refer to either or all of the following:</div> <br> <div><b>Corrective maintenance</b></div> <div>Include rectifying and repairing or faulty systems / equipment.</div> <br> <div><b>Preventive maintenance</b></div> <div>Include scheduled maintenance for systems / equipment (i.e. calibration).</div> <br> <div><b>Comprehensive maintenance</b></div> <div>Consists of both corrective and preventive maintenance.</div>',
  'OptionToPurchase': 'Additional goods and services to be purchased in the future that are not included in Firm Requirement, Extended Warranty and Maintenance.'
}
